import { render } from "./ComisionesList.vue?vue&type=template&id=29384dc0&scoped=true"
import script from "./ComisionesList.vue?vue&type=script&lang=js"
export * from "./ComisionesList.vue?vue&type=script&lang=js"

import "./ComisionesList.vue?vue&type=style&index=0&id=29384dc0&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29384dc0"]])

export default __exports__